module.exports = __webpack_public_path__ + "static/media/van.15c9799c.jpg";